import axios from '../axiosConfig'

import { tokenConfig } from './auth'
import { FETCH_TARIFA_ENVIO_PORTES, GET_TARIFA_ENVIO_PORTES, UPDATE_STATUS_PORTES } from './types'

export const getTarifasEnvioPortes =
  (id_pedido_seleccionado = '') =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_TARIFA_ENVIO_PORTES,
    })
    axios
      .get(
        `/tarifasEnvioPortes/?id_pedido_seleccionado=${id_pedido_seleccionado}`,
        tokenConfig(getState),
      )
      .then(res => {
        dispatch({
          type: GET_TARIFA_ENVIO_PORTES,
          payload: res.data,
        })
      })
      .catch(err => console.log(err))
  }

export const actualizarAceptar = nuevo => (dispatch, getState) => {
  dispatch({
    type: UPDATE_STATUS_PORTES,
    payload: nuevo,
  })
}
